import React from 'react';
import HeroSection from '../components/HeroSection';
import LeadershipPhilosophy from '../components/LeadershipPhilosophy';
import StrategicAccomplishments from '../components/StrategicAccomplishments';
import ProfessionalJourney from '../components/ProfessionalJourney';
import ImpactStory from '../components/ImpactStory';
import MediaRecognition from '../components/MediaRecognition';
import AwardsHonors from '../components/AwardsHonors';
import ContactSection from '../components/ContactSection';

const Home = () => {
  return (
    <div className="home-container">
      <HeroSection />
      <LeadershipPhilosophy />
      <StrategicAccomplishments />
      <ProfessionalJourney />
      <ImpactStory />
      <MediaRecognition />
      <AwardsHonors />
      <ContactSection />
    </div>
  );
};

export default Home;